import type { ComponentChildren } from "preact";

export interface RingProps {
  readonly size: number;
  readonly stroke: number;
  readonly fraction: number;
  readonly color?: string;
  readonly children?: ComponentChildren;
}

export function Ring({
  size,
  stroke,
  fraction,
  color = "var(--brand-accent)",
  children,
}: RingProps) {
  const sweep = Math.max(0, Math.min(1, fraction)) * 290;
  const radius = (size - stroke) / 2;
  const center = size / 2;
  const angle = (sweep * Math.PI) / 180;
  const x = center + radius * Math.sin(angle);
  const y = center - radius * Math.cos(angle);
  const path =
    sweep > 0
      ? `M ${center} ${center - radius} A ${radius} ${radius} 0 ${sweep > 180 ? 1 : 0} 1 ${x} ${y}`
      : null;
  return (
    <span class="d-ring" style={{ width: `${size}px`, height: `${size}px` }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        {path ? (
          <path d={path} fill="none" stroke={color} stroke-width={stroke} stroke-linecap="round" />
        ) : null}
      </svg>
      {children ? <span class="d-ring-label">{children}</span> : null}
    </span>
  );
}
